"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delegationFrontendSchema = void 0;
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var currentDate = utils_1.getCurrentDate();
exports.delegationFrontendSchema = {
    type: 'object',
    required: ['endDate', 'fromUserID', 'moduleTypeCodes', 'startDate', 'toUserID'],
    properties: {
        actingUserTitleTypeCode: {
            type: ['number'],
            minimum: 0,
            maximum: 9999,
            errorMessage: 'should be a number between 1-9999',
        },
        activationTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be up to 128 characters',
        },
        endDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
            formatMinimum: {
                $data: '1/startDate',
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DELEGATION_END_DATE_PROIR_TO_DELEGATION_START_DATE, 'endDate'),
            },
        },
        expiryTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        fromUserID: {
            type: 'string',
            isNotEmpty: true,
        },
        moduleTypeCodes: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'integer',
                enum: Object.values(constants_1.Module),
                errorMessage: 'Should equate to a valid Module Enum value',
            },
            errorMessage: 'Should equate to an array of valid Module Enum values',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should be a UUIDv4',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should be a UUIDv4',
        },
        startDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should be formatted as yyyy-mm-dd',
            formatMinimum: {
                const: currentDate,
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_START_DATE_BEFORE_CURRENT, 'startDate'),
            },
        },
        toUserID: {
            type: 'string',
            isNotEmpty: true,
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    fromUserID: {
                        const: '',
                    },
                },
            },
            else: {
                properties: {
                    fromUserID: {
                        type: 'string',
                        format: 'uuid',
                        errorMessage: 'Should be a UUIDv4',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    toUserID: {
                        const: '',
                    },
                },
            },
            else: {
                properties: {
                    toUserID: {
                        type: 'string',
                        format: 'uuid',
                        errorMessage: 'Should be a UUIDv4',
                    },
                },
            },
        },
    ],
};
